import React from "react";
import { Sparkles } from "lucide-react";
import { LANDING } from "@/constants/testIds";

const Bonus = () => {
  return (
    <section
      data-testid={LANDING.bonusSection}
      className="py-16 md:py-24 px-6 md:px-12"
    >
      <div className="max-w-5xl mx-auto rounded-[2rem] md:rounded-[2.5rem] bg-gradient-to-r from-[#00B2A9]/10 via-[#EF426F]/10 to-[#FF8200]/10 border border-black/5 p-8 md:p-14 text-center relative overflow-hidden">
        <div className="pointer-events-none absolute -top-24 left-1/2 -translate-x-1/2 w-[420px] h-[420px] rounded-full bg-white blur-3xl opacity-60" />
        <div className="relative">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-white border border-black/5 shadow-sm">
            <Sparkles size={14} className="text-[#FF8200]" strokeWidth={2.5} />
            <span className="text-[10px] md:text-xs font-bold uppercase tracking-[0.2em]">
              🎁 Bonus for Quick Action Takers
            </span>
          </div>
          <h2 className="mt-6 text-3xl md:text-5xl font-black tracking-tighter leading-[1.05] max-w-3xl mx-auto">
            Free{" "}
            <span className="bg-gradient-to-r from-[#00B2A9] via-[#EF426F] to-[#FF8200] text-transparent bg-clip-text">
              AI Search Visibility Audit
            </span>
          </h2>
          <p className="mt-5 text-base md:text-lg text-zinc-600 leading-relaxed max-w-2xl mx-auto">
            Claim your spot before all 10 spots are filled and receive a complimentary
            AI Search Visibility Audit. We'll show you whether customers can find your
            business on ChatGPT and AI-powered search engines, plus identify
            opportunities to increase your visibility.
          </p>
        </div>
      </div>
    </section>
  );
};

export default Bonus;
